import messages from './ListeUtilisateurs.json'
import moment from 'moment';
import Utilisateur from './Utilisateur/Utilisateur.vue'

export default {
  name: "ListeUtilisateurs",
  i18n: messages,

  components: {
    Utilisateur
  },

  data() {
    return {
      form: {
        search: '',
        fonction: null,
        datesPoste: '',
        fonctionEnable: true,
        utilisateur: null
      },

      // Gestion IHM
      controls: {
        form: {
          login: {
            loading: false,
            available: null
          },
          structureEnable: true,
          fonctionEnable: true
        }
      },
      modal: {
        search: null,
        users: []
      },
      data: {
        rechercheUtilisateur: []
      },
      control: {
        showModal: false,
        emptyResult: null
      }
    }
  },

  mounted() {
    this.updateData();
  },

  methods: {
    /**
     * Récupération des données
     */
    updateData() {
      let urlBack = 'rest/bd/utilisateur/structure'
      if (this.$val.isDefined(this.$route.params.idStructure)) {
        urlBack += '/' + this.$route.params.idStructure
      } else {
        console.error('Paramétre attendu absent : idStructure')
      }
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios.get(urlBack).then(
        response => {
          this.data = response.data;
          this.updateDataSuccess(response.data)
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        },
        error => {
          this.updateDataFailed(error.response)
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        }
      )
    },

    /**
     * Formatte les utilisateurs pour la liste déroulante. 
     * @param {*} users 
     */
    formatUsersForListe(users){
      users.forEach(element => {
        let item = {
          'id': element.id,
          'value': element.prenom + ' ' + element.nom,
          'mail' : element.mail
        }
        this.modal.users.push(item)
      })
    },

    /**
     * Données filtrées après recherche
     */
    filteredList() {
      return this.data.utilisateursEnCours.filter(utilisateur => {
        return (utilisateur.nom + utilisateur.prenom).toLowerCase().includes(this.form.search.toLowerCase())
      })
    },

    /**
     * Save le poste
     */
    savePoste() {

      let dto = {
        structure: {
          id: this.$route.params.idStructure
        },
        fonction: {
          id: this.form.fonction
        },
        utilisateur: {
          id: this.form.utilisateur
        },
        dateDebut: this.form.datesPoste[0],
        dateFin: this.form.datesPoste[1]
      }

      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios.post('/rest/bd/poste', dto).then(
        response => {
          this.$notify.success({
            title: this.$t('notifications.succesEnregistrement.title'),
            message: this.$t('notifications.succesEnregistrement.message')
          })
          this.updateData();
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        }, error => {
          if (error.data.businessCode) {
            this.$notify.error({
              title: this.$t('notifications.' + error.data.businessCode + '.title'),
              message: this.$t('notifications.' + error.data.businessCode + '.message')
            })
          } else {
            // Erreur générale
            this.$notify.error({
              title: this.$t('notifications.echecEnregistrement.title'),
              message: this.$t('notifications.echecEnregistrement.message')
            })
          }
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        }
      )
    },

    /**
     * Vérification du formulaire 
     */
    submitForm() {
      this.$validator.validateAll().then(isValid => {
        isValid ? this.control.showModal = false : ''
        return isValid ? this.savePoste() : null;
      })
    },
    /**
     * Change l'état de l'utilisateur
     * @param {*} id 
     * @param {*} state 
     */
    changeState(id, state) {
      let dto = {
        id: id,
        actif: state
      }
      this.$eventHub.$emit(this.$eventHub.LOADING.START);
      this.$axios.put('rest/bd/utilisateur/state', dto).then(
        response => {
          this.$eventHub.$emit(this.$eventHub.SHOW_NOTIF, 'success', this.$t('notifications.succesChgtEtat.title'), null)
          this.$eventHub.$emit(this.$eventHub.LOADING.END);
        },
        error => {
          this.$eventHub.$emit(this.$eventHub.SHOW_NOTIF, 'error', this.$t('notifications.echecChgtEtat.title'), this.$t('notifications.echecChgtEtat.message'))
          this.$eventHub.$emit(this.$eventHub.LOADING.END);
        }
      )
    },

    /**
     * Routage
     */
    gotoNewUser() {
      if (this.$val.isDefined(this.$route.params.idStructure)) {
        this.$router.push({
          path: '/pages/admin/user/' + this.$route.params.idStructure + '/new'
        })
      } else {
        console.error('Paramétre attendu absent : idStructure')
      }
    },

    /**
     * Routage
     * @param {*} user 
     */
    gotoUserDetail(user) {
      localStorage.setItem('selectedUser', JSON.stringify(user))
      this.$router.push({
        path: '/pages/admin/user/detail/' + user.id
      })
    },


    /**
     * Action lors de la selection sur le autocomplete
     * @param {*} item 
     */
    handleSearch(item) {
      this.form.utilisateur = item.id
    },


    querySearch(queryString, cb) {
      var results = queryString ? this.modal.users.filter(this.createFilter(queryString)) : this.modal.users;
      cb(results);
    },


    createFilter(queryString) {
      return (user) => {
        return (user.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0)
      };
    },

    /**
     * Appelé lorsque la récupération des données s'est bien passée
     */
    updateDataSuccess(data) {
      if (this.$val.isDefined(data)) {
        this.control.emptyResult = false
        //this.data.utilisateurs = data ;
        this.formatUsersForListe(data.rechercheUtilisateur.utilisateurs)
        this.checkFunction(data.rechercheUtilisateur.fonctions)
      } else {
        this.control.emptyResult = true
      }
    },

    /**
     * Notifie qu'aucune fonction n'a été trouvé
     * @param {*} error 
     */
    checkFunction(fonctions){
      switch (fonctions) {
        case 0:
          // Problème configuration => alerte IHM
          this.$notify.error({
            title: this.$t('notifications.noFonction.title'),
            message: this.$t('notifications.noFonction.message')
          })
          this.form.fonction = null
          this.controls.form.fonctionEnable = false
          break;
        case 1:
          // 1 seul élément => sélectionné par défaut
          this.form.fonction = response.data[0].id
          break;
        default:
          break;
      }
    },

    /**
     * Appelé lorsque la récupération des données s'est mal passée
     */
    updateDataFailed(error) {
      // On notifie l'erreur a l'utilisateur
      this.$notify.error({
        title: this.$t('notifications.echecRecuperationDonnees.title'),
        message: this.$t('notifications.echecRecuperationDonnees.message')
      })
    }
  },

  watch: {}

}
